import { PopoverPortal as UIKitPopoverPortal } from "@circle-react-shared/uikit/PopoverPortal";
import { LazyChatThreadsList } from "@circle-react/components/Chat/ChatThreads/LazyChatThreadsList";
import { CommunityFeatureFlagsContextProvider } from "@circle-react/contexts/communityFeatureFlagsContext";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useUnreadChatThreads } from "@circle-react/hooks/chatsV2/useUnreadChatThreads";

import { DEFAULT_POPPER_OPTIONS } from "../constants";
import { ChatThreadsPopoverButton } from "./ChatThreadsPopoverButton";
import { Header } from "./Header";

export const ChatThreads = () => {
  const { currentCommunityMember, isViewOnlyMasquerading } =
    usePunditUserContext();
  const { unreadThreadsCount } = useUnreadChatThreads();

  const shouldDisplayChatThreads =
    currentCommunityMember?.policies?.can_access_threads_tab ||
    unreadThreadsCount > 0;

  if (!shouldDisplayChatThreads) {
    return null;
  }

  return (
    <CommunityFeatureFlagsContextProvider>
      <UIKitPopoverPortal
        renderButton={isOpen => <ChatThreadsPopoverButton isOpen={isOpen} />}
        className={classNames(
          "border-primary bg-primary size-full max-h-[37rem] max-w-[30rem] rounded-md border shadow-lg",
          {
            "cursor-not-allowed": isViewOnlyMasquerading,
          },
        )}
        popperOptions={DEFAULT_POPPER_OPTIONS}
        shouldHideOnMdScreens={false}
      >
        <div
          className={classNames("size-full", {
            "pointer-events-none": isViewOnlyMasquerading,
          })}
          data-testid="chat-threads-drawer"
        >
          <Header />
          <div
            className="bg-secondary h-[calc(100%-61px)] w-full overflow-y-auto rounded-b-md p-3"
            id="chat-threads-header"
          >
            <LazyChatThreadsList isRenderedOnHeader />
          </div>
        </div>
      </UIKitPopoverPortal>
    </CommunityFeatureFlagsContextProvider>
  );
};
